import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Button,
} from '../../components';
import { HVC_GROEP_URL } from '../../config/constants';
import { ReactComponent as MaintenanceIcon } from '../../assets/images/icons/maintenance.svg';


import './style.scss';

const Maintenance = () => {

  const { t } = useTranslation();
  const title = t('maintenance');

  return (
    <Container small className="maintenance u-margin--top-bottom--8 row justify-content-center">

      <MaintenanceIcon/>      

      <h1 className="maintenance__title">{title}</h1>

      <Button type="primary" href={HVC_GROEP_URL}>{t('maintenance_button_hvcgroep')}</Button>

    </Container>
  );
};

export default Maintenance;
